var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterAir(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#fff;}.d{fill:#002455;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.273,27.482H4.726A1.083,1.083,0,0,1,3.644,26.4V8.6A1.083,1.083,0,0,1,4.726,7.519H30.273A1.083,1.083,0,0,1,31.356,8.6V26.4a1.083,1.083,0,0,1-1.083,1.083"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.083-.75H26.63a1.834,1.834,0,0,1,1.832,1.832v17.8a1.834,1.834,0,0,1-1.832,1.832H1.083A1.835,1.835,0,0,1-.75,18.88V1.083A1.835,1.835,0,0,1,1.083-.75ZM26.63,19.213a.332.332,0,0,0,.332-.332V1.082A.332.332,0,0,0,26.63.75H1.083a.333.333,0,0,0-.333.333v17.8a.333.333,0,0,0,.333.333Z",
    transform: "translate(3.644 7.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(17.5 16.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(14.048 16.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(10.596 16.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(20.952 16.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(24.404 16.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(17.5 22.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(14.048 22.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(10.596 22.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(20.952 22.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(24.404 22.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(17.5 9.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(14.048 9.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(10.596 9.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(20.952 9.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.265a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V2.515A.75.75,0,0,1,0,3.265Z",
    transform: "translate(24.404 9.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.6.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H20.6a.75.75,0,0,1,.75.75A.75.75,0,0,1,20.6.75Z",
    transform: "translate(7.2 14.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M20.6.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H20.6a.75.75,0,0,1,.75.75A.75.75,0,0,1,20.6.75Z",
    transform: "translate(7.2 20.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 3.03,
    height: 23.259,
    transform: "translate(3.644 5.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0-.75H3.03A.75.75,0,0,1,3.78,0V23.259a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75ZM2.28.75H.75V22.509H2.28Z",
    transform: "translate(3.644 5.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 3.03,
    height: 23.259,
    transform: "translate(28.326 5.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0-.75H3.03A.75.75,0,0,1,3.78,0V23.259a.75.75,0,0,1-.75.75H0a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75ZM2.28.75H.75V22.509H2.28Z",
    transform: "translate(28.326 5.87)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterAir);
export default __webpack_public_path__ + "static/media/icon_filter_air.99e4f688d6fbf4f895e988b7d262808f.svg";
export { ForwardRef as ReactComponent };